// src/components/select/FolderSelector.tsx

import { FormControl, MenuItem, TextField } from '@mui/material'
import { type ChangeEvent } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import { FolderId, FolderPool } from '@/types/domain/folder'

import { useCurrentFolder, useFolderPool } from '../../hooks'

const SORT_ATTR_NAME = (a, b) => {
  const nameA = String(a.attributes.name).toUpperCase()
  const nameB = String(b.attributes.name).toUpperCase()

  if (nameA < nameB) return -1
  if (nameA > nameB) return 1

  return 0
}

export const FolderSelector = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const fPool: FolderPool = useFolderPool()
  const id: FolderId = useCurrentFolder()

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const id = Number(event.target.value)
    if (!id) return

    const to = pathname.match(/^\/folder\/\d+\/home/)
      ? pathname.replace(/^\/folder\/\d+/, `/folder/${id}`)
      : `/folder/${id}/home/performance`

    navigate(to)
  }

  return (
    <FormControl sx={{ width: 600 }}>
      <TextField onChange={onChange} select value={id ?? 0}>
        <MenuItem disabled value={0}>
          Meine Gebäude
        </MenuItem>

        {fPool.sort(SORT_ATTR_NAME).map(f => (
          <MenuItem key={f.id} value={f.id}>
            {f.attributes.name}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  )
}
